module.exports = __webpack_public_path__ + "c72aac1ee42ab8a395371de1a3be9c2f.MP3";